import { NavigationConfig } from "../components/NavMenu";

export function filterApplicationConfigurations(applicationConfigurations) {
  applicationConfigurations = applicationConfigurations.filter(
    (application) => "categoryId" in application
  );

  return applicationConfigurations.map((application) => ({
    id: application.id,
    label: application.label,
    url: application.route.path,
    categoryId: application.categoryId,
  }));
}

export function getCategories(applicationConfigurations) {
  return applicationConfigurations.reduce(
    (categories, app) => categories.add(app.categoryId),
    new Set()
  );
}

export function groupByCategory(
  categories: Set<string>,
  applicationConfigurations
) {
  const navigations: NavigationConfig[] = [];
  for (let category of Array.from(categories))
    navigations.push({
      categoryId: category,
      items: applicationConfigurations.filter(
        (application) => application.categoryId === category
      ),
    });

  return navigations;
}

export default function toNavigations(applicationConfigurations) {
  applicationConfigurations = filterApplicationConfigurations(
    applicationConfigurations
  );

  const categories: Set<string> = getCategories(applicationConfigurations);

  return groupByCategory(categories, applicationConfigurations);
}
